<template>
  <banner
    :icon="!hideIcon ? 'fa-check-circle' : ''"
    :title="title"
    class="success"
  >
    <slot></slot>
  </banner>
</template>
<script>
import Banner from "./Banner.vue";

export default {
  components: { Banner },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "sass:color";
@import "@/_css/variables";

.success {
  border-color: $green;
  color: $green;
  background-color: color.adjust($green, $lightness: 50%);
}
</style>
